import React from "react";

export default function Ring({ className }) {
  return (
    <>
      <svg
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="26" height="26" rx="13" fill="currentColor" />
        <circle cx="13" cy="13" r="6" fill="white" />
      </svg>
    </>
  );
}
